var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vital"},[_c('small',{staticClass:"text-muted",domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.value)}})])}
var staticRenderFns = []

export { render, staticRenderFns }